
import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import api from '../mainApi';

const Classes = () => {
  const [classes, setClasses] = useState([]);
  const [trainers, setTrainers] = useState([]);
  const [name, setName] = useState('');
  const [instructor, setInstructor] = useState('');
  const [class_time, setTime] = useState('');
  const [class_date, setDate] = useState('');

  const [showModal, setShowModal] = useState(false);
  const [selectedClass, setSelectedClass] = useState(null);

  useEffect(() => {
    api.get('classes')
      .then(res => setClasses(res.data))
      .catch(error => console.error('Error fetching classes:', error));
    api.get('trainers')
      .then(res => setTrainers(res.data))
      .catch(error => console.error('Error fetching trainers:', error));
  }, []);

  const addClass = (e) => {
    e.preventDefault();
    const newClass = { name, instructor, time: class_time, date: class_date };
    api.post('classes', newClass)
      .then(res => {
        setClasses([...classes, res.data]);
        setName('');
        setInstructor('');
        setTime('');
        setDate('');
      })
      .catch(error => console.error('Error adding class:', error));
  };

  const deleteClass = (id) => {
    api.delete(`classes/${id}`)
      .then(() => {
        setClasses(classes.filter(c => c.id !== id));
      })
      .catch(error => console.error('Error deleting class:', error));
  };

  const handleShowModal = (c) => {
    setSelectedClass(c);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedClass(null);
  };

  const handleUpdateClass = (e) => {
    e.preventDefault();
    const updatedClass = {
      name: selectedClass.name,
      instructor: selectedClass.instructor,
      time: selectedClass.class_time,
      date: selectedClass.class_date
    };
    api.put(`classes/${selectedClass.id}`, updatedClass)
      .then(res => {
        setClasses(classes.map(c => c.id === res.data.id ? res.data : c));
        handleCloseModal();
      })
      .catch(error => console.error('Error updating class:', error));
  };

  return (
    <div>
      <h2>Classes</h2>
      <form onSubmit={addClass}>
        <div className="row">
          <div className="col-md-3">
            <input type="text" className="form-control" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} required />
          </div>
          <div className="col-md-3">
            <select className="form-control" value={instructor} onChange={(e) => setInstructor(e.target.value)} required>
                <option value="">Select Instructor</option>
                {trainers.map(trainer => (
                    <option key={trainer.id} value={trainer.name}>{trainer.name}</option>
                ))}
            </select>
          </div>
          <div className="col-md-2">
            <input type="time" className="form-control" placeholder="Time" value={class_time} onChange={(e) => setTime(e.target.value)} required />
          </div>
          <div className="col-md-2">
            <input type="date" className="form-control" placeholder="Date" value={class_date} onChange={(e) => setDate(e.target.value)} required />
          </div>
          <div className="col-md-2">
            <button type="submit" className="btn btn-primary">Add Class</button>
          </div>
        </div>
      </form>

      <hr />

      <table className="table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Instructor</th>
            <th>Time</th>
            <th>Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {classes.map(c => (
            <tr key={c.id}>
              <td>{c.id}</td>
              <td>{c.name}</td>
              <td>{c.instructor}</td>
              <td>{c.class_time}</td>
              <td>{c.class_date}</td>
              <td>
                <button className="btn btn-primary btn-sm me-2" onClick={() => handleShowModal(c)}>Edit</button>
                <button className="btn btn-danger btn-sm" onClick={() => deleteClass(c.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {selectedClass && (
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Class</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleUpdateClass}>
              <div className="mb-3">
                <label htmlFor="name" className="form-label">Name</label>
                <input type="text" className="form-control" id="name" value={selectedClass.name} onChange={(e) => setSelectedClass({ ...selectedClass, name: e.target.value })} required />
              </div>
              <div className="mb-3">
                <label htmlFor="instructor" className="form-label">Instructor</label>
                <select className="form-control" id="instructor" value={selectedClass.instructor} onChange={(e) => setSelectedClass({ ...selectedClass, instructor: e.target.value })} required>
                    <option value="">Select Instructor</option>
                    {trainers.map(trainer => (
                        <option key={trainer.id} value={trainer.name}>{trainer.name}</option>
                    ))}
                </select>
              </div>
              <div className="mb-3">
                <label htmlFor="time" className="form-label">Time</label>
                <input type="time" className="form-control" id="time" value={selectedClass.class_time} onChange={(e) => setSelectedClass({ ...selectedClass, class_time: e.target.value })} required />
              </div>
              <div className="mb-3">
                <label htmlFor="date" className="form-label">Date</label>
                <input type="date" className="form-control" id="date" value={selectedClass.class_date} onChange={(e) => setSelectedClass({ ...selectedClass, class_date: e.target.value })} required />
              </div>
              <Button variant="primary" type="submit">
                Save Changes
              </Button>
            </form>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};

export default Classes;
